import { Button } from '@/shared/components';
import type { OtaBookingRefundCategory, OtaBookingRefundLedgerItem } from '@/shared/api';
import { formatDateTime, formatMoney } from '@/shared/lib/format';
import { majorFromMinor } from '@/shared/lib/money';

function categoryLabel(category: OtaBookingRefundCategory): string {
  return category === 'Defect' ? 'Mangel' : 'Gästebeschwerde';
}

/** Verlauf der dokumentierten Erstattungen; eine Erstattung lässt sich einmal kompensieren. */
export function OtaRefundHistory({
  items,
  onCompensate,
}: {
  items: OtaBookingRefundLedgerItem[];
  onCompensate: (refundId: string) => void;
}) {
  if (items.length === 0) return null;
  return (
    <div className="border-hairline space-y-2 border-t pt-3">
      <p className="text-ink-soft text-xs font-medium">Verlauf</p>
      {items.map((item) => (
        <div
          key={item.id}
          className="border-hairline rounded-control flex flex-col gap-2 border p-3 text-sm sm:flex-row sm:items-center sm:justify-between"
        >
          <div>
            <p className="font-semibold">
              {item.kind === 'Compensation' ? 'Kompensation' : categoryLabel(item.category)}
            </p>
            <p className="text-ink-soft text-xs">
              {formatDateTime(item.createdAt)}
              {item.isCompensated ? ' · kompensiert' : ''}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="font-mono font-semibold tabular-nums">
              {formatMoney(majorFromMinor(item.amountMinor, item.currency), item.currency)}
            </span>
            {item.kind === 'Refund' && !item.isCompensated && (
              <Button
                size="sm"
                variant="ghost"
                className="min-h-11 sm:min-h-8"
                onClick={() => onCompensate(item.id)}
              >
                Kompensieren
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
